(() => {
	let subMenu = document.querySelector('.submenu');
	if (!subMenu) {
		return;
	}
	const hiddenClass     = 'submenu--hidden';
	let previousScrollTop = 0;
	let threshold         = 200;
	let navElementHeight  = 200;
	let timer;
	let shouldHide        = () => {
		return previousScrollTop >= threshold;
	};

	let isHidden    = () => {
		return subMenu.classList.contains(hiddenClass);
	};
	let checkScroll = () => {
		let scrollTop        = window.pageYOffset || document.documentElement.scrollTop;
		let scrollingUpwards = scrollTop < previousScrollTop;
		previousScrollTop    = scrollTop;
		if (scrollingUpwards && scrollTop > navElementHeight) {
			if (isHidden()) {
				subMenu.classList.remove(hiddenClass);
			}
			return;
		}
		if ((isHidden() || !shouldHide()) && scrollTop > navElementHeight) {
			return;
		}
		subMenu.classList.add(hiddenClass);
	};
	window.addEventListener('scroll', function () {
		clearTimeout(timer);
		timer = setTimeout(checkScroll, 25);
	});
	subMenu.classList.add('submenu--transitions-enabled');
})();